// src/Components/Sidebar.js
import React, { useState } from "react";
import { ListGroup, ListGroupItem, Collapse } from "reactstrap";
import { Link, useNavigate  } from 'react-router-dom';
import logo from '../Assets/App_icon/logo.png';
import logout from '../Assets/App_icon/logout.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState(""); 
  const [childOpenSection, setChildOpenSection] = useState(""); 

  const username = localStorage.getItem('username');
  const cityname = localStorage.getItem('cityname');
  const userRole = localStorage.getItem('userRole');
 

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('store');
    localStorage.removeItem('cityname');
    localStorage.removeItem('userid');
    localStorage.removeItem('username');
    localStorage.removeItem('userRole'); 
    navigate('/'); 
  };

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? "" : section));
    setChildOpenSection((prev) => (prev === "" ));
  };
  const childToggleSection = (childsection) => {
    setChildOpenSection((prev) => (prev === childsection ? "" : childsection));
  };

  return (
    <div className="sidebar">
      {/* Logo Header */}
        <div className="sidebar_header">
            <Link to="/app/Homepage" style={{ textDecoration: 'none' }}>
              <img  className="logo-image" src={logo} alt="Stonita Fresh"/>
            </Link>
          
        </div>   


      {/* Menu Sections */}
        <div className="sidebar_middle">
          <ListGroup flush>
             {/* Report Section */}
                  <Link to="/app/dashboard" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="menuItem">Dashboard</ListGroupItem>
                  </Link>

            {/* Transaction Section */}
              <div className="divider" onClick={() => toggleSection("transaction")}>Transaction </div>
              <Collapse isOpen={openSection === "transaction"}>
                  <Link to="/app/Trans_order" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Order</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_packing" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Packing</ListGroupItem>
                  </Link>
                  <Link to="/app/Master_delman" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Deliveryman</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_cash_entry" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Cash Entry</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_purchase" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Purchase</ListGroupItem>
                  </Link>
                  <Link to="/app/Trans_wasteg" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Wasteg</ListGroupItem>
                  </Link>                 
              </Collapse>

            {/* Product Section */}
              <div className="divider" onClick={() => toggleSection("product")}>Product</div>
              <Collapse isOpen={openSection === "product"}>
                <Link to="/app/Master_product" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Product</ListGroupItem>
                </Link>
                <Link to="/app/Master_category" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Category</ListGroupItem>
                </Link>
                <Link to="/app/Acc_hsncode" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">HSN Code</ListGroupItem>
                </Link>
              </Collapse>

            {/* Master Section */}
              <div className="divider" onClick={() => toggleSection("master")}>Master</div>
              <Collapse isOpen={openSection === "master"}>
                <Link to="/app/Master_customer" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Customer</ListGroupItem>
                </Link>
                <Link to="/app/Master_area" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Area</ListGroupItem>
                </Link>
                <Link to="/app/Master_users" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Users</ListGroupItem>
                </Link>
                 <Link to="/app/Master_welcome_image" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Welcome Image</ListGroupItem>
                </Link>
                
                {userRole === 'Admin' && (
                  <Link to="/app/Master_wapi_login" style={{ textDecoration: 'none' }}>
                    <ListGroupItem className="childMenuItem">Whatsapp</ListGroupItem>
                  </Link>
                )}
              </Collapse>

            {/* Report Section */}
              <div className="divider" onClick={() => toggleSection("report")}>Report </div>
              <Collapse isOpen={openSection === "report"}>
                  <div className="subdivider" onClick={() => childToggleSection("Order")}>Order</div>
                    <Collapse isOpen={childOpenSection === "Order"}>
                        <Link to="/app/Report_ord_prd" style={{ textDecoration: 'none' }}>
                          <ListGroupItem className="childMenuItem">Product wise</ListGroupItem>
                        </Link>
                    </Collapse> 
                  <div className="subdivider" onClick={() => childToggleSection("sales")}>Sales</div>
                    <Collapse isOpen={childOpenSection === "sales"}>
                        <Link to="/app/Trans_sales" style={{ textDecoration: 'none' }}>
                          <ListGroupItem className="childMenuItem">Sales Master</ListGroupItem>
                        </Link>
                    </Collapse>    
                  <div className="subdivider" onClick={() => childToggleSection("PL")}>PL</div>
                    <Collapse isOpen={childOpenSection === "PL"}>
                        <Link to="/app/Report_PL" style={{ textDecoration: 'none' }}>
                          <ListGroupItem className="childMenuItem">PL Report</ListGroupItem>
                        </Link>
                    </Collapse>     
              </Collapse>

            {/* Account Section */}
              <div className="divider" onClick={() => toggleSection("account")}>Account</div>
              <Collapse isOpen={openSection === "account"}>
                <Link to="/app/Acc_accparty" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Account</ListGroupItem>
                </Link>
                <Link to="/app/Acc_expence" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Expence</ListGroupItem>
                </Link>
              </Collapse>

            {/* Marketing Section */}
              <div className="divider" onClick={() => toggleSection("notification")}>Marketing</div>
              <Collapse isOpen={openSection === "notification"}>
                <Link to="/app/Mkt_notification" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="childMenuItem">Notification</ListGroupItem>
                </Link>
              </Collapse>  

            {/* Stock Section */}
                <Link to="/app/Report_stock" style={{ textDecoration: 'none' }}>
                  <ListGroupItem className="menuItem">Stock</ListGroupItem>
                </Link>
          </ListGroup>
        </div>  


      {/* Logout Footer */}
        <div className="sidebar_footer">
           <div style={{ textDecoration: 'none',  display: 'flex'  }}>
              <div onClick={handleLogout} className="sidebar_footer_lougout_image" >
                <img  className="icon-image" src={logout} alt="Logout"/>
              </div>
              <div className="sidebar_footer_user_detail" >
                <p style={{ marginLeft: '5px', fontSize: '12px' }}> {username} <br /> {cityname} </p>
              </div>
              
              
            </div>
        </div>
    </div>
  );
};

export default Sidebar;